

const getTemplateName = (templates, targetId) => {
  const foundTemplate = templates.find((template) => template._id === targetId);
  return (foundTemplate === null || foundTemplate === void 0 ? void 0 : foundTemplate.name) || targetId;
};

export { getTemplateName };